import { render, staticRenderFns } from "./historytakingnote.vue?vue&type=template&id=5f7b081e&"
import script from "./historytakingnote.vue?vue&type=script&lang=js&"
export * from "./historytakingnote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports